import React, { Fragment,  useContext } from 'react'
import operatorContext from '../../../context/operator/operatorContext'

const OperatorRequestPayout = () => {

    const OperatorContext = useContext(operatorContext);

    const { requestPayout } = OperatorContext; //has not been created yet tho


    const onSubmit = e => {

        e.preventDefault()

        let request_payout = document.getElementById("request_payout");

        let new_request_payout = new FormData(request_payout);
        requestPayout(new_request_payout).then(res => { //end point has not been created also
            console.log(res)
        })
    }

    return (
        <Fragment>
            <div className="content-wrapper">
            <div className="container-fluid">
                <h3 className="make-bold">Request Payout</h3>
                <p>Request to withdraw earnings</p>
                {/* <!--Start Dashboard Content--> */}

                <div className="dashboard-inner-view">
                    <div className="row mt-3">
                        <div className="col-lg-8">

                            <ul className="profile-tab-view nav nav-pills mb-5" id="pills-tab" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active ft-1-5" id="pills-personal-information-tab"
                                        data-toggle="pill" href="#pills-personal-information" role="tab"
                                        aria-controls="pills-personal-information" aria-selected="true">Withdraw
                                       Earnings</a>
                                </li> 
                            </ul>
                            <div className="tab-content" id="pills-tabContent">

                                <div className="tab-pane fade show active" id="pills-personal-information" role="tabpanel"
                                    aria-labelledby="pills-home-tab">
                                    <div className="profile-info-details">
                                        <div className="row">
                                            <div className="col-lg-7">
                                                <form onSubmit={onSubmit} id="request_payout">
                                                
                                                    <div className="form-group mb-5">
                                                        <label>How much do you want to withdraw</label>
                                                        <input type="text" className="form-control form-control-custom-view"
                                                            name='amount'
                                                            placeholder="42,000" required />
                                                    </div>
                                                    <div className="form-group mb-5">
                                                        <label>Bank Name</label>
                                                        <select name="bank_name" className="form-control form-control-custom-view">
                                                            <option value="uba">United Bank for Africa</option>
                                                            <option value="access">Access Bank</option>
                                                            <option value="first" >First Bank</option>
                                                            <option value="gtb">Guarantee Trust Bank</option>
                                                            <option value="zenith">Zenith Bank</option>
                                                        </select>
                                                    </div>
                                                    <div className="form-group mb-5">
                                                        <label>Account Name</label>
                                                        <input type="text" className="form-control form-control-custom-view"
                                                            name='account_name'
                                                            placeholder="Obi Nkemjika Derick" required />
                                                    </div>
                                                    <div className="form-group mb-5">
                                                        <label>Account Type</label>
                                                        <input type="text" className="form-control form-control-custom-view"
                                                            name='account_type'
                                                            placeholder="Savings" required />
                                                    </div>
                                                   
                                                    <div className="form-row">
                                                        <div className="form-group col-lg-4">
                                                            <input type="submit" value="REQUEST" 
                                                                className="btn btn-orange btn-custom-view text-white btn-block d-flex justify-content-center align-items-center"
                                                                    />
                                                           
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="col-lg-3">
                                                <a href="!#">
                                                    <div className="position-relative">
                                                        <div className="avatar-holder-profile bord-radius-50 mx-auto">
                                                            <img src="assets/images/avatar-big.png"
                                                                className="img-fluid object-fit-cover object-pos-center h-100 w-100" alt="" />
                                                        </div>
                                                        <img src="assets/images/vector-avatar.png"
                                                            className="img-fluid vector-avatar-overlay" alt="" />
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <!--End Dashboard Content--> */}

            </div>
            {/* <!-- End container-fluid--> */}

        </div>
        {/* End wrapper */}
       
        </Fragment>
    )
}

export default OperatorRequestPayout
